import React, { Suspense } from 'react';
import { Route } from 'react-router';
import {
    discountSettings,
    generalSettingService,
    globalPropertySettings,
    privCardCompanySettings,
    registrationDeferredMrsOrderQueueSettings,
    reportTemplates,
} from '../constants/constants';
import GenericSettingContainer from '../containers/GenericSettingContainer/GenericSettingContainer';
import PageLoader from '../components/PageLoader/PageLoader';

const privCardCompanyPage = React.lazy(() => import('../pages/MiscSettingsPages/PrivCardCompanyPage'));
const GlobalPropertySettingsPage = React.lazy(() => import('../pages/MiscSettingsPages/GlobalPropertySettingsPage'));
const DiscountSettingsPage = React.lazy(() => import('../pages/MiscSettingsPages/DiscountSettingsPage'));
const reportTemplatesPage = React.lazy(() => import('../pages/MiscSettingsPages/ReportTemplatesPage/ReportTemplatesPage'));
const GeneralSettingPage = React.lazy(() => import('../pages/ServicePages/GeneralSettingPage'));
const RegistrationDeferredMrsOrderQueuePage = React.lazy(() => import('../pages/MiscSettingsPages/RegistrationDeferredMrsOrderQueuePage'));

const MiscSettingsRoutes = props => (
    <GenericSettingContainer {...props}>
        <Suspense fallback={<PageLoader />}>
            <Route path={globalPropertySettings} exact component={GlobalPropertySettingsPage} />
            <Route path={generalSettingService} exact component={GeneralSettingPage} />
            <Route path={discountSettings} exact component={DiscountSettingsPage} />
            <Route path={privCardCompanySettings} exact component={privCardCompanyPage} />
            <Route path={reportTemplates} exact component={reportTemplatesPage} />
            <Route
                path={registrationDeferredMrsOrderQueueSettings}
                exact
                component={RegistrationDeferredMrsOrderQueuePage}
            />
        </Suspense>
    </GenericSettingContainer>
);

export default MiscSettingsRoutes;
